import { type Logger as DataDogLogger } from '@datadog/browser-logs';

import { type Environment } from './utils/environments';

import packageJson from '../../package.json' with { type: 'json' };

type LoggerConfig = {
	applicationName: string | undefined;
	env: Environment;
};

type LogFunction = DataDogLogger['error'];

export class Logger {
	private logger: DataDogLogger | undefined;

	constructor(config: LoggerConfig) {
		if (typeof window !== 'undefined' && window.DD_LOGS && config.applicationName) {
			this.setUpLogger(config);
		}
	}

	private setUpLogger(config: LoggerConfig): void {
		this.logger = window.DD_LOGS.createLogger('web-analytics-sdk', {
			context: {
				service: 'web-analytics-sdk',
				applicationName: config.applicationName,
				env: config.env,
				lib: {
					version: packageJson.version,
				},
			},
		});
	}

	public error: LogFunction = (...args) => {
		this.logger?.error(...args);
	};

	public info: LogFunction = (...args) => {
		this.logger?.info(...args);
	};
}
